// Parents of a web transaction as GET /edit-details lists them: the primary
// parent first, then the second parent (the checkout's emergency contact).
// The website's event register page asks for an emergency contact only when
// the event collects one (workshop.emergency_contact_ind); without one the
// server lists that second parent with its name, email and phone null. It is
// not a person to match, and the import skips it (server #179,
// createMissingFamilyUsers). A collected contact is matched as before.

const isBlank = (v) => v == null || String(v).trim() === "";

// A secondary parent with no name, email or phone: shown as not collected,
// never matched, and not needed before Import.
export const isBlankSecondParent = (parent, index) =>
  index > 0 &&
  Number(parent?.primaryInd) !== 1 &&
  ["firstName", "lastName", "email", "phone"].every((k) => isBlank(parent?.[k]));

// "Jane Doe", without "null" for a missing part; "" when both are missing.
export const parentName = (parent) =>
  [parent?.firstName, parent?.lastName].filter((n) => !isBlank(n)).join(" ");
